import {Outlet, useLocation, useParams} from "react-router-dom"
import ApiDatabase from 'server'
import {useEffect} from "react";
import UseContext from "hooks/useContext";

// Every route is served by the same index.html, so the static <title> in it can
// only ever describe one page. Matching is ordered: the first pattern that
// matches wins, so narrower paths must come before the ones that would also
// swallow them.
const TITLE_KEY_BY_PATH = [
    [/^\/login\/interimaire/, 'loginTempWorker'],
    [/^\/login\/entreprise/, 'loginCompany'],
    [/^\/register\/landing\//, 'finalizeRegistration'],
    [/^\/register\/interimaire/, 'registerTempWorker'],
    [/^\/forgot\//, 'forgot'],
    [/^\/lostForgot\//, 'resetPassword'],
    [/^\/invite\//, 'invitation'],
    [/\/invitation$/, 'finalizeAccount'],
]

const Layout = () => {
    const {updateUser, language}=UseContext()
    const location = useLocation();
    const tokenURL=location.search.split('=')[1]

    // `language` is rebuilt on every provider render, so depending on it here
    // would re-run this for nothing; its contents never change at runtime.
    useEffect(() => {
        const fallback = language.getValue(
            'pageTitles.fallback',
            "Jobbiz - agence d'intérim digitale"
        )
        const match = TITLE_KEY_BY_PATH.find(([pattern]) => pattern.test(location.pathname))
        document.title = match
            ? language.getValue(`pageTitles.${match[1]}`, fallback)
            : fallback
    }, [location.pathname])

    // useEffect(()=>{
    //     if(tokenURL){
    //         ApiDatabase.postRoleUser({token:tokenURL},
    //             (data)=>{
    //                 updateUser(data.token_refresh,data.role)
    //                 window.location.replace('/interimaire')
    //             },
    //             (err)=>{
    //                 console.log(err)})
    //     }
    // },[])

    return (
        <>
            <Outlet />
        </>
    )
}

export default Layout
